module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSelect),
      expression: "isShowSelect"
    }],
    staticClass: "mask",
    on: {
      "click": function($event) {
        _vm.isShowSelect = !_vm.isShowSelect
      }
    }
  }), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom-start",
      "width": _vm.width,
      "trigger": "manual",
      "size": "mini"
    },
    on: {
      "hide": _vm.popoverHide
    },
    model: {
      value: (_vm.isShowSelect),
      callback: function($$v) {
        _vm.isShowSelect = $$v
      },
      expression: "isShowSelect"
    }
  }, [_c('el-select', {
    ref: "select",
    staticClass: "tree-select",
    style: (_vm.selectStyle),
    attrs: {
      "slot": "reference",
      "size": "mini",
      "multiple": _vm.multiple,
      "clearable": _vm.clearable,
      "collapse-tags": _vm.collapseTags
    },
    on: {
      "remove-tag": _vm.removeSelectedNodes,
      "clear": _vm.removeSelectedNode,
      "change": _vm.changeSelectedNodes
    },
    nativeOn: {
      "click": function($event) {
        _vm.isShowSelect = !_vm.isShowSelect
      }
    },
    slot: "reference",
    model: {
      value: (_vm.selectedData),
      callback: function($$v) {
        _vm.selectedData = $$v
      },
      expression: "selectedData"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-tree', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "tree",
    staticClass: "common-tree",
    style: (_vm.style),
    attrs: {
      "data": _vm.data,
      "size": _vm.size,
      "props": _vm.defaultProps,
      "show-checkbox": _vm.multiple,
      "node-key": _vm.nodeKey,
      "check-strictly": _vm.checkStrictly,
      "expand-on-click-node": true,
      "check-on-click-node": _vm.multiple,
      "highlight-current": true
    },
    on: {
      "node-click": _vm.handleNodeClick,
      "check-change": _vm.handleCheckChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-d41c17f6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common_page/search_tree_select.vue
// module id = T9R5
// module chunks = 81